import angular from 'angular';

const module = angular.module('whyline.services.theme', [
  'whyline.services.theme',
]);

let $location;
let $state;

class ThemeService {

  static $inject = ['$location', '$state'];

  constructor(injected$location, injected$state) {
    $location = injected$location;
    $state = injected$state;
  }

  getTenantIdBySubdomain(){
    const url = $location.absUrl();
    const urlParts = url.substring(url.indexOf('://') + 3).split('.');
    const subdomain = urlParts[0];

    let tenantId = null;

    switch(subdomain){
      case 'macroqms':
      case 'macro':
        tenantId = 'macro'; 
        break;
      case 'ficohsa':
        tenantId = 'ficohsa';
        break;
    }

    return tenantId;
  }

  getTenantIdBySlug(slug){

    let tenantId = null;

    slug = slug.replace(/ /g, "-");
    slug = slug.toLowerCase();

    switch(slug){
      case 'atm-misiones':
        tenantId = 'atm-misiones';
        break;
      case 'andreani':
        tenantId = 'andreani'; 
        break;
      case 'santander-mx':
        tenantId = 'santander-mx';
        break;
      case 'sim': 
        tenantId = 'sim';
        break;
      case 'auna': 
      tenantId = 'auna';
        break;
    }

    return tenantId;
  }

  getTenantIdByParam(){
    return $state.params.tenantId;
  }

  getTenantId = (slug) => {
    const tenantIdByParam = this.getTenantIdByParam();
    const tenantIdBySubdomain = this.getTenantIdBySubdomain();
    const tenantIdBySlug = this.getTenantIdBySlug(slug);
  
    return tenantIdByParam || tenantIdBySubdomain || tenantIdBySlug;
  };
  
  getThemeClass = (slug) => {

    const tenantId = this.getTenantId(slug);
    let themeClass = tenantId || '';
    themeClass = themeClass.replace(/ /g, "-");
    themeClass = themeClass.toLowerCase();

    return themeClass;
  }
  
  getDisplayAnimationClass = (slug) => {
  
    let tenantId = this.getTenantId(slug);
  
    let animationClass = 'green-flash';
  
    switch(tenantId) {
      case 'ficohsa':
        animationClass = 'ficohsa-flash';
        break;
    }
  
    return animationClass;
  }

}

module.exports = module.service('ThemeService', ThemeService);